import { Page } from "@/libs/model/common/index";
export * from "@/libs/model/common";
export * from "@/libs/model/login";
export * from "@/libs/model/user";
export * from "@/libs/model/game";
export * from "@/libs/model/school";
export * from "@/libs/model/club";
export * from "@/libs/model/base";
export * from "@/libs/model/football";
export * from "@/libs/model/coache";
export * from "@/libs/model/directory";
export * from "@/libs/model/cultivate";
export * from "@/libs/model/sports";
export * from "@/libs/model/resetPassword";
export const page = new Page();
